import { computed } from "vue";
import { fabric } from "fabric";
import { store } from "@/store";

import {
  makeRectLabel,
  makeCircleLabel,
  makeLabelFromMask,
  makeFlyerLabel,
} from "@/canvas-api/DrawLabel";

const currentLabel = computed(() => store.getters.currentLabel);
const currentLabelType = computed(() => store.getters.currentLabelType);
const currentLabelBgColor = computed(() => store.getters.currentLabelBgColor);

const templateAndLabel = computed(() => store.getters.templateAndLabel);
const userArtworkFetch = computed(() => store.getters.userArtworkFetch);
const editorParams = computed(() => store.getters.editorParams);

export default async (canvas: fabric.Canvas): Promise<void> => {
  const backgroundColor = currentLabelBgColor.value ? currentLabelBgColor.value : undefined;

  switch (Number(currentLabel.value.shape_id)) {
    case 3:
    case 4: {
      return makeRectLabel(canvas, backgroundColor);
    }
    case 5: {
      switch (currentLabelType.value) {
        case "custom-printed":
        case "printed": {
          return await makeLabelFromMask(canvas, backgroundColor, "oval");
        }
        case "custom-rollprinted":
        case "rollprinted": {
          return await makeLabelFromMask(canvas, backgroundColor, "oval");
        }
        default: {
          return await makeLabelFromMask(canvas, backgroundColor, "oval");
        }
      }
    }
    case 2:
    case 6:
    case 7:
    case 8: {
      return await makeLabelFromMask(canvas, backgroundColor);
    }
    case 10: {
      if (currentLabelType.value === "flyer") {
        if (templateAndLabel.value.label && templateAndLabel.value.label.mask_id) {
          return await makeFlyerLabel(canvas, backgroundColor, templateAndLabel.value.label.mask_id);
        } else if (
          userArtworkFetch.value.params &&
          userArtworkFetch.value.label &&
          userArtworkFetch.value.label.mask_id
        ) {
          return await makeFlyerLabel(canvas, backgroundColor, userArtworkFetch.value.label.mask_id);
        } else {
          return await makeFlyerLabel(canvas, backgroundColor, editorParams.value.mask_id);
        }
      } else {
        return makeCircleLabel(canvas, backgroundColor);
      }
    }
    default: {
      return makeRectLabel(canvas, backgroundColor);
    }
  }
}
